import {
  BusinessEmployee,
  GetBusinessInfoResponse,
  MyBusiness,
} from "@1games-ru/region-shared/dist/backend/requests/business";
import { EmployeeRole } from "@1games-ru/region-shared/dist/enums/business/employee";
import { BusinessRole } from "@1games-ru/region-shared/dist/enums/business/role";
import { useCallback, useLayoutEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import useAppDispatch from "@/core/helpers/useAppDispatch";
import useAppSelector from "@/core/helpers/useAppSelector";
import { Button, TabsNavigation } from "@/shared/ui";
import DeviceTabContentWrapper from "@/shared/widgets/DeviceTabContentWrapper";
import {
  employeesCurrentTabSelector,
  employeesIsDismissModalSelector,
  employeesListSelector,
  employeesSelectedEmployeeSelector,
  employeesTabsSelector,
  setEmployeesIsDismissModal,
  setSelectedEmployeesTab,
} from "@/domains/business/slice";
import { playerInfoSelector } from "@/domains/player/slice";
import useGetEmployees from "@/domains/business/hooks/useGetEmployees";
import BusinessDismissContainer from "@/domains/business/containers/tablet/BusinessDismissContainer";
import BusinessEmployeesList from "@/domains/business/components/employees/BusinessEmployeesList";

type Props = {
  info: MyBusiness | GetBusinessInfoResponse;
  onClose: () => void;
};

export default function BusinessEmployeesContainer({ info, onClose }: Props) {
  const { t } = useTranslation("business");
  const dispatch = useAppDispatch();

  const [selectedEmployee, setSelectedEmployee] = useState(null);

  const employeesList = useAppSelector(employeesListSelector);
  const employeesSelectedEmployee = useAppSelector(employeesSelectedEmployeeSelector);
  const employeesTabs = useAppSelector(employeesTabsSelector);
  const employeesCurrentTab = useAppSelector(employeesCurrentTabSelector);
  const employeesIsDismissModal = useAppSelector(employeesIsDismissModalSelector);
  const { character } = useAppSelector(playerInfoSelector);

  const { isPending, getEmployees } = useGetEmployees();

  const onDismiss = (employee: BusinessEmployee) => {
    setSelectedEmployee(employee);
    dispatch(setEmployeesIsDismissModal(true));
  };

  const changeCurrentTab = useCallback((tab) => dispatch(setSelectedEmployeesTab(tab)), [dispatch]);

  const header = employeesSelectedEmployee ? (
    <div className="flex items-center gap-2.5">
      <Button
        variant="soft"
        color="gray"
        className="p-0 w-[2rem] h-[2rem] shrink-0 font-arial text-[0.7rem]"
        // onClick={backHandler}
      >
        &#9668;
      </Button>
      <div className="text-18 text-white font-bold">{t("business.employees.info")}</div>
    </div>
  ) : (
    t("business.employees.title")
  );

  useLayoutEffect(() => {
    if (info.id) {
      getEmployees(info.id, [EmployeeRole.Manager, EmployeeRole.Worker]);
    }
  }, [info.id, getEmployees]);

  return (
    <>
      {employeesIsDismissModal && selectedEmployee && (
        <BusinessDismissContainer
          selectedEmployee={selectedEmployee}
          setSelectedEmployee={setSelectedEmployee}
          businessId={info.id}
        />
      )}
      <DeviceTabContentWrapper header={header} isLoading={isPending} onClose={onClose}>
        <TabsNavigation
          tabs={employeesTabs}
          selectedTab={employeesCurrentTab}
          i18fileName="business"
          i18Path="business.employees.tabs"
          onClick={changeCurrentTab}
        />
        <BusinessEmployeesList
          employees={employeesList || []}
          onChange={setSelectedEmployee}
          employeesCurrentTab={employeesCurrentTab}
          className="grow"
          onCall={() => {}}
          onMsg={() => {}}
          onDismiss={onDismiss}
          isHideDelete={info?.role === BusinessRole.Worker}
          isHideHandlersId={character?.id}
        />
      </DeviceTabContentWrapper>
    </>
  );
}
